import { AfterViewInit, Component, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { HasSubscriptions } from 'shared/components/higher-order/has-subscriptions';
import { LABELS } from 'shared/consts/labels.const';
import { InformationalWebLabels } from '../../informational-posting-web.utils';
import { combineLatest, Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { ServiceProvider } from '@gms/tsp-api';
import {
  getSelectedInfoPostTSP,
  selectAllInfoPostTSP,
  selectExcludeInfoPostTsp,
  selectPostingsListLoading,
} from 'app/store/infopost/infopost.selectors';
import { IInfoPostState } from 'app/store/infopost/infopost.state';
import { SidebarService } from 'shared/services/sidebar.service';
import { dateUtils } from 'shared/utils/date.utils';
import { MonthDay } from 'shared/components/cron-editor/cron-editor-pipes';
import { cancelRequest } from 'app/store/infopost/infopost.actions';

@Component({
  selector: 'app-infopost-main',
  templateUrl: './infopost-main.component.html',
  styleUrl: './infopost-main.component.scss',
})
export class InfoPostMainComponent extends HasSubscriptions implements OnInit, OnDestroy {
  title: string = InformationalWebLabels.HOMELABEL;
  INFO_POST = LABELS;
  thumbnailImgPath: string = null;
  detailedPdfPath: string = null;

  execludeTsp: number;

  COMMON_LABELS = LABELS;

  selectedTsp$: Observable<ServiceProvider> = this._store.pipe(select(getSelectedInfoPostTSP));

  allTspInfo$: Observable<ServiceProvider[]> = this._store.pipe(select(selectAllInfoPostTSP));

  isLoading$: Observable<boolean> = this._store.pipe(select(selectPostingsListLoading));

  isAccessInfopostPage: boolean;

  selectedTspId: number;
  selectedTsps: Array<ServiceProvider> = [];
  monthDayDisplay = new MonthDay();

  private selectExcludeInfoPostTsp$: Observable<ServiceProvider[]> = this._store.pipe(
    select(selectExcludeInfoPostTsp)
  );

  constructor(private _store: Store<IInfoPostState>, private sidebarService: SidebarService) {
    super();
  }

  ngOnInit() {
    this.tspSubscription();
    this.isAccessPageSubscription();
    this.excludeTspSubscription();
  }

  private tspSubscription() {
    this.addSubscriptions([
      combineLatest([this.selectedTsp$, this.allTspInfo$]).subscribe(
        ([selectedTsp, allTspInfo]) => {
          this.selectedTsps = [];
          if (selectedTsp && Object.keys(selectedTsp).length) {
            this.selectedTspId = selectedTsp.providerId;
            this.selectedTsps = [selectedTsp];
            this.sidebarService.isAccessPage(true);
          } else {
            this.selectedTsps = allTspInfo;
          }
        }
      ),
    ]);
  }

  private excludeTspSubscription() {
    this.addSubscriptions([
      this.selectExcludeInfoPostTsp$.subscribe((resp) => {
        if (resp && resp[0].providerId) {
          this.execludeTsp = resp[0].providerId;
        }
      }),
    ]);
  }

  private isAccessPageSubscription() {
    this.addSubscriptions([
      this.sidebarService.isAccessPage$.subscribe((isAccess) => {
        this.isAccessInfopostPage = isAccess;
      }),
    ]);
  }

  get currentDate() {
    const currDate = dateUtils.convertToCT(new Date());
    return `${dateUtils.getDayNameLong(currDate)}, ${dateUtils.getMonthNameLong(
      currDate
    )} ${this.monthDayDisplay.transform(currDate.getDate().toString())}, ${dateUtils.getDateAsAMPM(
      currDate
    )} CT`;
  }

  ngOnDestroy() {
    this._store.dispatch(cancelRequest());
    return super.ngOnDestroy();
  }
}
